import React, { Component } from 'react'
import { HashRouter as Router, Route } from 'react-router-dom'
import Login from './common/Login.js'
import Home from './common/Home.js'
import Dashboard from './common/Dashboard.js'
import LanguageList from './components/LanguageMaster/LanguageList.js'
import LanguageAdd from './components/LanguageMaster/LanguageAdd.js'
import CountryList from './components/LocationMaster/CountryMaster/CountryList.js'
import CountryAddTab from './components/LocationMaster/CountryMaster/CountryAddTab.js'
import GovernorateList from './components/LocationMaster/GovernorateMaster/GovernorateList.js'
import GovernorateAddTab from './components/LocationMaster/GovernorateMaster/GovernorateAddTab.js'
import RefundPolicyTab from './components/RefundPolicy/RefundPolicyTab.js'
import SellerPolicyTab from './components/SellerPolicy/SellerPolicyTab.js'
import BuyerPolicyTab from './components/BuyerPolicy/BuyerPolicyTab.js'
import TermsAddTab from './components/Terms/TermsAddTab.js'
import AboutUsAddTab from './components/AboutUs/AboutUsAddTab.js'
import ContactUsList from './components/ContactUs/ContactUsList.js'
import BannerList from './components/BannerMaster/BannerList.js'
import UserList from './components/UserMaster/Customer/UserList.js'
import UserAddTab from './components/UserMaster/Customer/UserAddTab.js'
import ContinentList from './components/LocationMaster/ContinentMaster/ContinentList.js'
import ContinentAddTab from './components/LocationMaster/ContinentMaster/ContinentAddTab.js'
import CityList from './components/LocationMaster/CityMaster/CityList.js'
import CityAddTab from './components/LocationMaster/CityMaster/CityAddTab.js'
import PaymentTypeAddTab from './components/PaymentTypeMaster/PaymentTypeAddTab.js'
import PaymentTypeList from './components/PaymentTypeMaster/PaymentTypeList.js'

import CaptainShopList from './components/UserMaster/Captain/CaptainList.js'
import CaptainShopAddTab from './components/UserMaster/Captain/CaptainAddTab.js'
import Booking from './components/Booking/Booking.js'
import Bookingdetail from './components/Booking/Bookingdetail.js'
import CategoryAdd from './components/Category/CategoryAdd.js'
import CategoryList from './components/Category/CategoryList.js'
import AreaList from './components/LocationMaster/AreaMaster/AreaList.js'
import AreaAddTab from './components/LocationMaster/AreaMaster/AreaAddTab.js'
import BookingAdditional from './components/Booking/Additinal.js'
import ProductsList from './components/ProductMaster/ProductsList.js'
import ProductsAddTab from './components/ProductMaster/ProductsAddTab.js'
import EventList from './components/EventMaster/EventList.js'
import EventAddTab from './components/EventMaster/EventAddTab.js'
import BoatsList from './components/BoatMaster/BoatsList.js'
import BoatsAddTab from './components/BoatMaster/BoatsAddTab.js'
import StoreList from './components/UserMaster/Store/StoreList.js'
import StoreAddTab from './components/UserMaster/Store/StoreAddTab.js'
import BoatOwnerList from './components/UserMaster/OwnerBoat/BoatOwnerList.js'
import BoatOwnerAddTab from './components/UserMaster/OwnerBoat/BoatOwnerAddTab.js'
import ShopDashboard from './common/ShopDashboard.js'
import BoatOwnerDashboard from './common/BoatOwnerDashboard.js'
import AdminDashboard from './common/AdminDashboard.js'
import ViewBoatDetails from './components/BoatMaster/ViewBoatDetails'
import DiwaniyaList from './components/DiwaniyaModal/DiwaniyaList'
import DestinationList from './components/DestinationModal/DestinationList.js'
import AddBanner from './components/BannerMaster/BannerAdd.js'
import GalleryList from './components/GalleryMaster/GalleryList.js'
import AddtionalHourList from './components/AdditionHourMaster/AdditionalHourLists'
import PickUpList from './components/PicUpMaster/PickUpList.js'
import BoatRatingList from './components/BoatRatings/BoatingRateList'
import PickUpAddTab from './components/PicUpMaster/PickUpAddTab.js'
import DestinationAddTab from './components/DestinationModal/DestinationAddTab.js'
import DiwaniyaAddTab from './components/DiwaniyaModal/DiwaniyaAddTab.js'
import AdditionalHoursAddTab from './components/AdditionHourMaster/AdditionalHoursAddTab.js'
import AssignedBoatCaptain from './components/UserMaster/OwnerBoat/AssignedBoatCaptain.js'
import BoatMasterTimeSlotList from './components/BoatMasterTimeSlot/BostMasterTimeslotList.js'
import BoatMasterTimeSlotAddTab from './components/BoatMasterTimeSlot/BoatMasterTimeSlotAddTab.js'
import AdminDestinationList from './components/AdminDestination/AdminDestinationList.js'
import AdminDestinationAddTab from './components/AdminDestination/AdminDestinationAddTab.js'
import AdminPickUpLists from './components/AdminPickUp/AdminPickUpList.js'
import AdminPickUpAddTab from './components/AdminPickUp/AdminPickUpAddTab..js'
import ContactDetails from './components/ContactUs/ContactDetails.js'
import invoicePrint from './components/Booking/Invoice.js'
import CouponLists from './components/Coupon/CouponList.js'
import CouponAddTab from './components/Coupon/CouponAddTab.js'
import VendorsList from './components/Vendors/VendorList.js'
import VendorsAddTab from './components/Vendors/VendorAddTab.js'
import TimeSlotMain from './components/TimeSlotMaster/TimeSLotsMain.js'
import BannerModuleList from './components/BannerModule/BannerModuleList.js'
import BannerModuleAdd from './components/BannerModule/BannerModuleAdd.js'
import BoatMasterTimeSlotButton from './components/BoatMasterTimeSlot/BoatMasterTimeSlotButton'
import AdminBooking from './components/AdminBooking/AdminBooking'
import StoreDetailsList from './components/StoreMaster/StoreDetailList.js'
import StoreDetailsAddTab from './components/StoreMaster/StoreDetailsAddTab.js'
import ProductStoreList from './components/StoreMaster/ProductStoreList.js'
import ProductStoreAddTab from './components/StoreMaster/ProductStoreAddTab.js'
import VendorsAddingTab from './components/UserMaster/Vendor/VendorsAddTab.js'
import VendorsListing from './components/UserMaster/Vendor/VendorsList.js'
import VendorDashboard from './common/VendorDashboard'
import CurrentBooking from './components/Booking/CurrentBooking.js'
import ProductImageList from './components/StoreMaster/ProductImage/ProductImageList'
import ProductImageAdd from './components/StoreMaster/ProductImage/ProductImageAdd'
import ClientDetails from './components/Client Setting/ClientSettingList'
import ClientSettingDetails from './components/Client Setting/ClientSettingDetails'
import NewEventList from './components/NewEventModule/NewEventList'
import NewEventBookingdetail from './components/NewEventModule/NewBookingDetail.js'
import TimeslotsEvent from './components/EventMaster/TimeslotsEvent'
import TimeslotEventAddTab from './components/EventMaster/AddTimeSlotEventTab'
import NotificationAdd from './components/Notification/NotificationAdd'
import NotificationAddV2 from './components/NotificationV2/NotificationAddV2'
import PushComposer from './components/PushNotification/PushComposer'
import PushHistory from './components/PushNotification/PushHistory'
import NotificationList from './components/Notifications/NotificationList'
import EventVendorList from './components/UserMaster/EventVendor/EventVendorList'
import EventVendorAddTab from './components/UserMaster/EventVendor/EventVendorAddTab'
import EventCompaniesList from './components/EventCompanies/EventCompaniesList'
import EventCompaniesAddTab from './components/EventCompanies/EventCompaniesAddTab'
import EventCompanyListSub from './components/EventCompanies/EventList'
import CompanyEventAddTab from './components/EventCompanies/EventAddTab'
import EventCategoryList from './components/EventCategory/EventCategoryList'
import EventCategoryAddTab from './components/EventCategory/EventCategoryAddTab'
import FandBSalesReports from './components/Reports/FandBSalesReport'
import BookingDetails from './components/Reports/BookingDetails'
import newUser from './components/Reports/newUser'
import ShopOwnerList from './components/UserMaster/ShopOwner/ShopOwnerList'
import ShopOwnerAddingTab from './components/UserMaster/ShopOwner/ShopOwnerAddTab'
import ShopCategoriesList from './components/ShopCategories/ShopCategoriesList'
import ShopCategoriesAddTab from './components/ShopCategories/ShopCategoriesAddTab'
import CountryAdminListing from './components/UserMaster/CountryAdmin/countryAdminList.js'
import CountryAdminAddTab from './components/UserMaster/CountryAdmin/countryAdminAddTab'
import BulkCoupon from './components/Coupon/BulkCoupon.js'
import CouponReportList from './components/Coupon/CouponReportList'
import OnboardingSetting from './components/OnboardingSetting/OnboardingSetting.js'
import HomeScreenMessages from './components/HomeScreenMessages/HomeScreenMessages.js'
import VoucherLists from './components/Voucher/VoucherList.js'
import VoucherAddTab from './components/Voucher/VoucherAddTab.js'
import CruiseFacilities from './components/CruiseFacilities/CruiseFacilities.js'
import ItemCategoryList from './components/ItemCategory/ItemCategoryList'
import ItemCategoryAddTab from './components/ItemCategory/ItemCategoryAddTab'
import TripList from './components/Trips/TripList.js'
import TripAddEdit from './components/Trips/TripAddEdit.js'
import ActivitiesList from './components/ActivitiesMaster/ActivitiesList.js'
import ActivitiesAddEdit from './components/ActivitiesMaster/ActivitiesAddEdit.js'
import YachtPolicyAddTab from './components/YachtPolicy/YachtPolicyTab.js'
import PrivacyPolicyAddTab from './components/RefundPolicy/PrivacyPolicyTab.js'

import { Context } from './context/LoaderContext'

import { io } from 'socket.io-client'
import { getAllUserTypes, getCountryTimeZone, socketUrl } from './Constant.js'
import NotificationSound from './notification.mp3'
import Swal from 'sweetalert2'
import BookingPayments from './components/Booking/BookingPayments.js'
import Moment from 'react-moment'
import StoreBookings from './components/Booking/StoreBookings.js'
import StoreBookingDetails from './components/Booking/StoreBookingDetails.js'
import DiwaniyaCategoryList from './components/DiwaniyaModal/DiwaniyaCategoryList.js'
import DiwaniyaCategoryAddEdit from './components/DiwaniyaModal/DiwaniyaCategoryAddEdit.js'
import StoreMapView from './components/StoreMapView/StoreMapView.js'
import AdsList from './components/Ads/AdsList.js'
import BookingV2 from './components/Booking/BookingV2.js'
import TopEventCategoryList from './components/TopEventCategory/EventCategoryList.js'
import EventCompaniesListV2 from './components/TopEventCategory/EventCompaniesList.js'
import TopEventCategoryAddTab from './components/TopEventCategory/EventCategoryAddTab.js'
import AllUserList from './components/UserMaster/Users/AllUserList.js'
import AddNewUser from './components/UserMaster/Users/AddNewUser.js'
import ChaletList from './components/ChaletMaster/ChaletList.js'
import ChaletAddTab from './components/ChaletMaster/ChaletAddTab.js'
import ChaletDetails from './components/ChaletMaster/ChaletDetails.js'

import DiwaniyaMasterList from './components/DiwaniyaMaster/DiwaniyaMasterList.js'
import DiwaniyaMasterAddTab from './components/DiwaniyaMaster/DiwaniyaMasterAddTab.js'
import CruiseIdReport from './components/Reports/CruiseIdReport.js'

import ReviewList from './components/AdminReview/ReviewList.js'
import ReviewAddTab from './components/AdminReview/ReviewAddTab.js'

import HolidayPriceList from './components/HolidayPrice/HolidayPriceList.js'
import HolidayPriceAddTab from './components/HolidayPrice/HolidayPriceAddTab.js'

import EventHolidayPriceList from './components/EventCompanies/HolidayPrice/HolidayPriceList.js'
import EventHolidayPriceAddTab from './components/EventCompanies/HolidayPrice/HolidayPriceAddTab.js'

import ChaletPackageList from './components/ChaletMaster/ChaletPackages/PackageList.js'
import ChaletPackageAddTab from './components/ChaletMaster/ChaletPackages/PackageAddTab.js'

import ChaletSlotList from './components/ChaletMaster/ChaletSlots/SlotList.js'
import ChaletSlotAddTab from './components/ChaletMaster/ChaletSlots/SlotAddTab.js'
import ChaletPolicyAdd from './components/ChaletMaster/ChaletPolicy/ChaletPolicyAdd.js'
import ChaletRefundPolicyAdd from './components/ChaletMaster/ChaletPolicy/ChaletRefundPolicy.js'
import ChaletBookingList from './components/ChaletMaster/ChaletBooking/BookingList.js'
import ChaletBookingDetail from './components/ChaletMaster/ChaletBooking/BookingDetails.js'
import ChaletDiwaniyaList from './components/ChaletMaster/ChaletDiwaniya/DiwaniyaList.js'

import VersionHistoryList from './components/VersionHistory/HistoryList.js'
import VersionHistoryAdd from './components/VersionHistory/HistoryAddTab.js'

import ChaletOwnerList from './components/UserMaster/ChaletOwner/ChaletOwnerList.js'
import ChaletOwnerAddTab from './components/UserMaster/ChaletOwner/ChaletOwnerAddTab.js'
import BasicReportChalet from './components/Reports/BasicReportChalet.js'
import TermsOwnerAddTab from './components/Terms/TermsOwnerAddTab.js'
import PrivacyPolicyOwnerAddTab from './components/RefundPolicy/PrivacyPolicyOwnerTab.js'
import AdsAddTab from './components/Ads/AdsAddTab.js'
import CouponController from './components/Coupon/CouponController.js'

import ChaletCategoryAddTab from './components/ChaletMaster/ChaletCategory/ChaletCategoryAddTab.js'
import ChaletCategoryList from './components/ChaletMaster/ChaletCategory/ChaletCategoryList.js'

import OfferList from './components/OfferMaster/OfferList.js'
import OfferAddTab from './components/OfferMaster/OfferAddTab.js'
import OfferCategoryList from './components/OfferMaster/OfferCategory/OfferCategoryList.js'
import OfferCategoryAddTab from './components/OfferMaster/OfferCategory/OfferCategoryAddTab.js'

import AllBookings from './components/Booking/AllBookings.js'
import EventReport from './components/Reports/BasicReportEvents.js'
import WalletReport from './components/Reports/WalletReport.js'
import UploadsAdd from './components/Uploads/UploadsAdd.js'
import VoucherReport from './components/Reports/VoucherReport.js'
import StoreReport from './components/Reports/StoreReport.js'
import ConciergeCruiseAdd from './components/Concierge/ConciergeAdd.js'
import AddOns from './components/Concierge/AddOns.js'
import JourneyList from './components/Journey/JourneyList.js'
import JourneyAddEdit from './components/Journey/JourneyAddEdit.js'
import CarCompanyList from './components/CarMaster/CarCompanyList.js'
import CarCompanyAddTab from './components/CarMaster/CarCompanyAddTab.js'
import CarList from './components/CarMaster/Cars/CarList.js'
import CarAddTab from './components/CarMaster/Cars/CarAddTab.js'
import CarCategoryList from './components/CarMaster/CarCategory/CarCategoryList.js'
import CarCategoryAdd from './components/CarMaster/CarCategory/CarCategoryAddTab.js'
import CarPricingList from './components/CarMaster/CarPricing/CarPricingList.js'
import CarPricingAdd from './components/CarMaster/CarPricing/CarPricingAddTab.js'
import CruiseComplaint from './components/ComplaintMaster/CruiseComplaint.js'
import ComplaintReport from './components/Reports/ComplaintReport.js'
import DataDeletionPolicyAdd from './components/YachtPolicy/DataDeletionPolicy/DataDeletionPolicyAdd.js'
import FinancialReport from './components/Reports/FinancialReport.js'
import ContractFiles from './components/ContractFiles/ContractFiles.js'
import ConciergeEventAdd from './components/ConciergeEvent/ConciergeEventAdd.js'
import CarPickupList from './components/CarMaster/CarPickup/CarPickupList.js'
import CarPickupAddTab from './components/CarMaster/CarPickup/CarPickupAddTab.js'
import CruiseBookingDetail from './components/PortAdmin/CruiseBookingdetail.js'
import MinaReport from './components/Reports/MinaReport.js'
import WegoDashboard from './components/Booking/WegoBookings.js'
import WegoReport from './components/Reports/WegoReport.js'
import PagesMetaDataCreate from './components/Client Setting/Meta Excel components/PagesMetaDataCreate.js'
import WegoUserReport from './components/Reports/WegoUserBookingReport.js'
import WegoNewUserReport from './components/Reports/WegoNewUserReport.js'
import FaqModuleList from './components/FAQ/FaqModuleList.js'
import FaqModuleAdd from './components/FAQ/FaqModuleAdd.js'
import ServiceAddTab from './components/Client Setting/ServiceAddTab.js'
import ChaletGlobalPackage from './components/ChaletMaster/ChaletGlobalPackages/PackageList.js'
import PackageAddEdit from './components/ChaletMaster/ChaletGlobalPackages/PackageAddEdit.js'
import AirportList from './components/AirportMaster/AirportList.js'
import AirportAddTab from './components/AirportMaster/AirportAddTab.js'
import DailyTripReport from './components/Reports/DailyTripReport.js'
import PortAdminEventReports from './components/Reports/PortAdminEventReport.js'
import FlightRedirectList from './components/AirportMaster/FlightRedirectList.js'
import EventBooking from './components/PortAdmin/EventBooking.js'
import PortAdminAllBookings from './components/PortAdmin/AllBookings.js'
import EventBookingdetails from './components/PortAdmin/EventBookingDetails.js'
import { Switch } from 'react-router-dom/cjs/react-router-dom.js'
import AnnualReport from './components/Reports/AnnualReport.js'

import axios from 'axios'
import CruiseDestinationList from './components/CruiseTripMaster/CruiseDestination/CruiseDestinationList.js'
import CruiseDestinationAddTab from './components/CruiseTripMaster/CruiseDestination/CruiseDestinationAddTab.js'
import CruiseTripAddTab from './components/CruiseTripMaster/CruiseTripAddTab.js'
import CruiseTripList from './components/CruiseTripMaster/CruiseTripList.js'
import CruiseTripDetails from './components/CruiseTripMaster/CruiseTripDetails.js'
import CruiseTripSlotList from './components/CruiseTripMaster/CruiseTripSlots/CruiseTripSlotList.js'
import CruiseTripSlotAddTab from './components/CruiseTripMaster/CruiseTripSlots/CruiseTripSlotAddTab.js'
import TripCruiseList from './components/CruiseTripMaster/TripCruise/TripCruiseList.js'
import TripCruiseAddTab from './components/CruiseTripMaster/TripCruise/TripCruiseAddTab.js'
import TripCabinAddTab from './components/CruiseTripMaster/TripCabin/TripCabinAddTab.js'
import TripCabinList from './components/CruiseTripMaster/TripCabin/TripCabinList.js'
import TripItineraryList from './components/CruiseTripMaster/TripItinerary/TripItineraryList.js'
import TripItineraryAddTab from './components/CruiseTripMaster/TripItinerary/TripItineraryAddTab.js'
import CruiseTripBookingDetail from './components/CruiseTripMaster/CruiseTripBookings/CruiseTripBookingDetails.js'
import BasicReportTrip from './components/Reports/BasicReportTrip.js'
import TripCabinPrice from './components/CruiseTripMaster/TripCabin/TripCabin&Price.js'
import ConciergeChaletAdd from './components/ConciergeChalet/ConciergeChaletAdd.js'
import BoatBlockDateList from './components/BoatMaster/BoatBlockDate/BoatBlockDateList.js'
import BoatMasterBlockDateAddTab from './components/BoatMaster/BoatBlockDate/BoatBlockDateAddTab.js'
import ConciergeKashtaAdd from './components/ConciergeKashta/ConciergeKashtaAdd.js'
import StoreBlockDateList from './components/StoreMaster/StoreBlockDate/StoreBlockDateList.js'
import StoreBlockDateAddTab from './components/StoreMaster/StoreBlockDate/StoreBlockDateAddTab.js'

axios.defaults.headers.common['app_type'] = `admin`
axios.defaults.headers.common['Content-Type'] = `application/json`

// Role-specific routes
const roleRoutes = {
  concierge: [
    {
      path: '/',
      component: ConciergeCruiseAdd,
    },
    {
      path: '/concierge-chalet',
      component: ConciergeChaletAdd,
    },
    {
      path: '/event-book',
      component: ConciergeEventAdd,
    },
    {
      path: '/all-bookings/:type?',
      component: AllBookings,
    },
    {
      path: '/booking-ordering/:booking_id?',
      component: Bookingdetail,
    },
    {
      path: '/add-ons',
      component: AddOns,
    },
    {
      path: '/concierge-kashta-book',
      component: ConciergeKashtaAdd,
    },
    {
      path: '/chalet-booking-details/:booking_id',
      component: ChaletBookingDetail,
    },
  ],
  'wego-admin': [
    {
      path: '/',
      component: WegoDashboard,
    },
    {
      path: '/reports',
      component: WegoReport,
    },
    {
      path: '/user-booking-reports',
      component: WegoUserReport,
    },
    {
      path: '/wego-new-user-reports',
      component: WegoNewUserReport,
    },
  ],
  'port-admin': [
    {
      path: '/',
      component: PortAdminAllBookings,
    },
    {
      path: '/port-bookings/:type?',
      component: PortAdminAllBookings,
    },
    {
      path: '/booking-details/:booking_id',
      component: CruiseBookingDetail,
    },
    {
      path: '/daily-trip-report',
      component: DailyTripReport,
    },
    {
      path: '/event-booking',
      component: EventBooking,
    },
    {
      path: '/event-booking-details/:booking_id',
      component: EventBookingdetails,
    },
    {
      path: '/daily-event-report',
      component: PortAdminEventReports,
    },
  ],
  vendor: [
    {
      path: '/',
      component: VendorDashboard,
    },
    {
      path: '/booking-ordering/:booking_id',
      component: Bookingdetail,
    },
    {
      path: '/current-booking',
      component: CurrentBooking,
    },
    {
      path: '/books-additional/:booking_id',
      component: BookingAdditional,
    },
    {
      path: '/booking/:booking_id',
      component: invoicePrint,
    },
    {
      path: '/booking-order',
      component: Booking,
    },
    {
      path: '/booking-order-v2',
      component: BookingV2,
    },
    {
      path: '/booking',
      component: Booking,
    },
    {
      path: '/admin-booking',
      component: AdminBooking,
    },
  ],
  captain: [
    {
      path: '/',
      component: Dashboard,
    },
    {
      path: '/booking-ordering/:booking_id',
      component: Bookingdetail,
    },
    {
      path: '/books-additional/:booking_id',
      component: BookingAdditional,
    },
    {
      path: '/booking-order',
      component: Booking,
    },
    {
      path: '/booking-order-v2',
      component: BookingV2,
    },
    {
      path: '/booking/:booking_id',
      component: invoicePrint,
    },
    {
      path: '/boatsmaster/:boatType?/:typeId?',
      component: (props) => (
        <BoatsList
          {...props}
          findPerson="UpdatingDom"
        />
      ),
    },
    {
      path: '/boatsmaster/cruise/:boatType?/add/:boatId?',
      component: BoatsAddTab,
    },
    {
      path: '/boat-Captain',
      component: CaptainShopList,
    },
    {
      path: '/boat-Captain/add/:Captain_id?',
      component: CaptainShopAddTab,
    },
    {
      path: '/viewboat-details/:boatType?/:boatId?',
      component: ViewBoatDetails,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/diwaniya-lists',
      component: DiwaniyaList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/diwaniya-add/:diwaniya_Id?',
      component: DiwaniyaAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/destination-lists',
      component: DestinationList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/destination-add/:destination_Id',
      component: DestinationAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/banner-lists',
      component: BannerList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/banner-add',
      component: AddBanner,
    },
    {
      path: '/gallary-list/:type/:id?',
      component: GalleryList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/additionhours-lists',
      component: AddtionalHourList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/additionalhours-add/:additional_hour_id?',
      component: AdditionalHoursAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/pickup-lists',
      component: PickUpList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/pickup-add/:pickupId?',
      component: PickUpAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boatRating-lists',
      component: BoatRatingList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boat-timeslot-lists',
      component: BoatMasterTimeSlotList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boat-available-timeslots/:timeId?',
      component: BoatMasterTimeSlotButton,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boat-timeslot-add/:boat_timeslot_id?',
      component: BoatMasterTimeSlotAddTab,
    },
    {
      path: '/customproduct',
      component: ProductsList,
    },
    {
      path: '/customproduct/add',
      component: ProductsAddTab,
    },
    {
      path: '/booking',
      component: Booking,
    },
    {
      path: '/category/add/:category_id?',
      component: CategoryAdd,
    },
    {
      path: '/store',
      component: StoreList,
    },
    {
      path: '/store/add/:Store_id?',
      component: StoreAddTab,
    },
  ],
  store: [
    {
      path: '/',
      component: ShopDashboard,
    },
    {
      path: '/store-details',
      component: StoreDetailsList,
    },
    {
      path: '/store-products/:storeDetail_id?',
      component: ProductStoreList,
    },
    {
      path: '/storeProductsImage/:productId?',
      component: ProductImageList,
    },
    {
      path: '/storeProductsImageAdd/:productId?/:type?',
      component: ProductImageAdd,
    },
    {
      path: '/store-details/add/:storeDetail_id?',
      component: StoreDetailsAddTab,
    },
    {
      path: '/store-details/:storeId?/store-block-date-lists',
      component: StoreBlockDateList,
    },
    {
      path: '/store-details/:storeId?/store-block-date-add/:store_block_date_id?',
      component: StoreBlockDateAddTab,
    },
    {
      path: '/product-details/add/:storeDetail_id?/:store_id?',
      component: ProductStoreAddTab,
    },
    {
      path: '/booking-ordering/:booking_id',
      component: Bookingdetail,
    },
    {
      path: '/current-booking',
      component: CurrentBooking,
    },
    {
      path: '/books-additional/:booking_id',
      component: BookingAdditional,
    },
    {
      path: '/booking/:booking_id',
      component: invoicePrint,
    },
    {
      path: '/booking-order',
      component: Booking,
    },
    {
      path: '/booking-order-v2',
      component: BookingV2,
    },
    {
      path: '/chalet-bookings',
      component: ChaletBookingList,
    },
    {
      path: '/chalet-booking-details/:booking_id',
      component: ChaletBookingDetail,
    },
    {
      path: '/booking',
      component: Booking,
    },
    {
      path: '/admin-booking',
      component: AdminBooking,
    },
    {
      path: '/booking-payments',
      component: BookingPayments,
    },
    {
      path: '/store-bookings',
      component: StoreBookings,
    },
    {
      path: '/store-bookings-details/:id',
      component: StoreBookingDetails,
    },
  ],
  admin: [
    {
      path: '/',
      component: BoatOwnerDashboard,
    },
    {
      path: '/booking-ordering/:booking_id',
      component: Bookingdetail,
    },
    {
      path: '/books-additional/:booking_id',
      component: BookingAdditional,
    },
    {
      path: '/booking-order',
      component: Booking,
    },
    {
      path: '/booking-order-v2',
      component: BookingV2,
    },
    {
      path: '/booking/:booking_id',
      component: invoicePrint,
    },
    {
      path: '/boatsmaster/:boatType?/:typeId?',
      component: (props) => (
        <BoatsList
          {...props}
          findPerson="UpdatingDom"
        />
      ),
    },
    {
      path: '/boatsmaster/cruise/:boatType?/add/:boatId?',
      component: BoatsAddTab,
    },
    {
      path: '/boat-Captain',
      component: CaptainShopList,
    },
    {
      path: '/boat-Captain/add/:Captain_id?',
      component: CaptainShopAddTab,
    },
    {
      path: '/viewboat-details/:boatType?/:boatId?',
      component: ViewBoatDetails,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/diwaniya-lists',
      component: DiwaniyaList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/diwaniya-add/:diwaniya_Id?',
      component: DiwaniyaAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/destination-lists',
      component: DestinationList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/destination-add/:destination_Id',
      component: DestinationAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/banner-lists',
      component: BannerList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/banner-add',
      component: AddBanner,
    },
    {
      path: '/gallary-list/:type/:id?',
      component: GalleryList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/additionhours-lists',
      component: AddtionalHourList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/additionalhours-add/:additional_hour_id?',
      component: AdditionalHoursAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/pickup-lists',
      component: PickUpList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/pickup-add/:pickupId?',
      component: PickUpAddTab,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boatRating-lists',
      component: BoatRatingList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boat-timeslot-lists',
      component: BoatMasterTimeSlotList,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boat-available-timeslots/:timeId?',
      component: BoatMasterTimeSlotButton,
    },
    {
      path: '/boatsmaster/:boatType?/:boatId?/boat-timeslot-add/:boat_timeslot_id?',
      component: BoatMasterTimeSlotAddTab,
    },
    {
      path: '/customproduct',
      component: ProductsList,
    },
    {
      path: '/customproduct/add',
      component: ProductsAddTab,
    },
    {
      path: '/booking',
      component: Booking,
    },
    {
      path: '/category/add/:category_id?',
      component: CategoryAdd,
    },
    {
      path: '/store',
      component: StoreList,
    },
    {
      path: '/store/add/:Store_id?',
      component: StoreAddTab,
    },
  ],
}

const superAdminRoutes = [
  {
    path: '/',
    component: AdminDashboard,
  },
  {
    path: '/languages',
    component: LanguageList,
  },
  {
    path: '/languages/add/:language_id?',
    component: LanguageAdd,
  },
  {
    path: '/booking-ordering/:booking_id?',
    component: Bookingdetail,
  },
  {
    path: '/books-additional/:booking_id?',
    component: BookingAdditional,
  },
  {
    path: '/booking/:booking_id',
    component: invoicePrint,
  },
  {
    path: '/new-events',
    component: NewEventList,
  },
  {
    path: '/new-evt/:booking_id?',
    component: NewEventBookingdetail,
  },
  {
    path: '/event-timeslots/:eventId?',
    component: TimeslotsEvent,
  },
  {
    path: '/event-timeslots/:event_id?/event-timeslotadd/:eventTimeslot_id?',
    component: TimeslotEventAddTab,
  },
  {
    path: '/booking-order',
    component: Booking,
  },
  {
    path: '/booking-order-v2',
    component: BookingV2,
  },
  {
    path: '/events/add/:event_id?',
    component: EventAddTab,
  },
  {
    path: '/events',
    component: EventList,
  },
  {
    path: '/boatsmaster/:boatType?/:typeId?',
    component: (props) => (
      <BoatsList
        {...props}
        findPerson="UpdatingDom"
      />
    ),
  },
  {
    path: '/viewboat-details/:boatType?/:boatId?',
    component: ViewBoatDetails,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/diwaniya-lists',
    component: DiwaniyaList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/diwaniya-add/:diwaniya_Id?',
    component: DiwaniyaAddTab,
  },
  {
    path: '/diwaniya-categories',
    component: DiwaniyaCategoryList,
  },
  {
    path: '/diwaniya-categories/:action/:id?',
    component: DiwaniyaCategoryAddEdit,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/destination-lists',
    component: DestinationList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/destination-add/:destination_Id?',
    component: DestinationAddTab,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/banner-lists',
    component: BannerList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/banner-add',
    component: AddBanner,
  },
  {
    path: '/gallary-list/:type/:id?',
    component: GalleryList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/additionhours-lists',
    component: AddtionalHourList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/additionalhours-add/:additional_hour_id?',
    component: AdditionalHoursAddTab,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/pickup-lists',
    component: PickUpList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/pickup-add/:pickupId?',
    component: PickUpAddTab,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/boatRating-lists',
    component: BoatRatingList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/boat-timeslot-lists',
    component: BoatMasterTimeSlotList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/boat-available-timeslots/:timeId?',
    component: BoatMasterTimeSlotButton,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/boat-timeslot-add/:boat_timeslot_id?',
    component: BoatMasterTimeSlotAddTab,
  },
  {
    path: '/des-tination-list',
    component: AdminDestinationList,
  },
  {
    path: '/notification',
    component: NotificationAdd,
  },
  {
    path: '/notifications',
    component: NotificationList,
  },
  {
    path: '/bannerModule-lists',
    component: BannerModuleList,
  },
  {
    path: '/bannerModule-lists/add/:bannerId?',
    component: BannerModuleAdd,
  },
  {
    path: '/store-details',
    component: StoreDetailsList,
  },
  {
    path: '/store-products/:storeDetail_id?',
    component: ProductStoreList,
  },
  {
    path: '/storeProductsImage/:productId?',
    component: ProductImageList,
  },
  {
    path: '/storeProductsImageAdd/:productId?/:type?',
    component: ProductImageAdd,
  },
  {
    path: '/store-details/add/:storeDetail_id?',
    component: StoreDetailsAddTab,
  },
  {
    path: '/store-details/:storeId?/store-block-date-lists',
    component: StoreBlockDateList,
  },
  {
    path: '/store-details/:storeId?/store-block-date-add/:store_block_date_id?',
    component: StoreBlockDateAddTab,
  },
  {
    path: '/product-details/add/:storeDetail_id?/:store_id?',
    component: ProductStoreAddTab,
  },
  {
    path: '/store-bookings',
    component: StoreBookings,
  },
  {
    path: '/store-bookings-details/:id',
    component: StoreBookingDetails,
  },
  {
    path: '/des-tination-list/add/:des_id?',
    component: AdminDestinationAddTab,
  },
  {
    path: '/pick-up-list',
    component: AdminPickUpLists,
  },
  {
    path: '/pickup/add/:pickupId?',
    component: AdminPickUpAddTab,
  },
  {
    path: '/coupon-controller',
    component: CouponController,
  },
  {
    path: '/coupon',
    component: CouponLists,
  },
  {
    path: '/coupon/add/:coupon_id?',
    component: CouponAddTab,
  },
  {
    path: '/vendor',
    component: VendorsList,
  },
  {
    path: '/Vendor/add/:Vendors_id?',
    component: VendorsAddTab,
  },
  {
    path: '/event-vendors',
    component: EventVendorList,
  },
  {
    path: '/country-admin',
    component: CountryAdminListing,
  },
  {
    path: '/country-admin/add/:country_id?',
    component: CountryAdminAddTab,
  },
  {
    path: '/fandb-sales-summary-report',
    component: FandBSalesReports,
  },
  {
    path: '/basic-report-cruise/:type',
    component: BookingDetails,
  },
  {
    path: '/basic-report-chalet',
    component: BasicReportChalet,
  },
  {
    path: '/new-user-report',
    component: newUser,
  },
  {
    path: '/cruise-id-report',
    component: CruiseIdReport,
  },
  {
    path: '/event/vendors/add/:event_vendor_id?',
    component: EventVendorAddTab,
  },
  {
    path: '/event-companies',
    component: EventCompaniesList,
  },
  {
    path: '/event-companies/add/:company_id?',
    component: EventCompaniesAddTab,
  },
  {
    path: '/view-event-company/:company_id?',
    component: EventCompanyListSub,
  },
  {
    path: '/view-event-company/add/:company_id?/:id?',
    component: CompanyEventAddTab,
  },
  {
    path: '/event-category',
    component: EventCategoryList,
  },
  {
    path: '/event-category/add/:category_id?',
    component: EventCategoryAddTab,
  },
  {
    path: '/top-event-companies/:id',
    component: EventCompaniesListV2,
  },
  {
    path: '/top-event-category',
    component: TopEventCategoryList,
  },
  {
    path: '/top-event-category/add',
    component: TopEventCategoryAddTab,
  },
  {
    path: '/top-event-category/add/:category_id',
    component: TopEventCategoryAddTab,
  },
  {
    path: '/boatsmaster/cruise/:boatType?/add/:boatId?',
    component: BoatsAddTab,
  },
  {
    path: '/users',
    component: UserList,
  },
  {
    path: '/users/add/:customer_id?',
    component: UserAddTab,
  },
  {
    path: '/customproduct',
    component: ProductsList,
  },
  {
    path: '/customproduct/add',
    component: ProductsAddTab,
  },
  {
    path: '/shop-owner',
    component: ShopOwnerList,
  },
  {
    path: '/shop-owner/add/:shopOwner_ids?',
    component: ShopOwnerAddingTab,
  },
  {
    path: '/shop-categories',
    component: ShopCategoriesList,
  },
  {
    path: '/shop-categories/add/:category_id?',
    component: ShopCategoriesAddTab,
  },
  {
    path: '/vendors',
    component: VendorsListing,
  },
  {
    path: '/vendors/add/:Vendors_ids?',
    component: VendorsAddingTab,
  },
  {
    path: '/booking',
    component: Booking,
  },
  {
    path: '/admin-booking',
    component: AdminBooking,
  },
  {
    path: '/current-booking',
    component: CurrentBooking,
  },
  {
    path: '/booking-payments',
    component: BookingPayments,
  },
  {
    path: '/category/add/:category_id?',
    component: CategoryAdd,
  },
  {
    path: '/category',
    component: CategoryList,
  },
  {
    path: '/boat-Captain',
    component: CaptainShopList,
  },
  {
    path: '/timeslot',
    component: TimeSlotMain,
  },
  {
    path: '/boat-Captain/add/:Captain_id?',
    component: CaptainShopAddTab,
  },
  {
    path: '/boat-Owner',
    component: BoatOwnerList,
  },
  {
    path: '/boat-Owner/alloted-captain/:ownerId?',
    component: AssignedBoatCaptain,
  },
  {
    path: '/boat-Owner/add/:boatOwner_id?',
    component: BoatOwnerAddTab,
  },
  {
    path: '/continent',
    component: ContinentList,
  },
  {
    path: '/continent/add/:continent_id?',
    component: ContinentAddTab,
  },
  {
    path: '/country',
    component: CountryList,
  },
  {
    path: '/store',
    component: StoreList,
  },
  {
    path: '/store/add/:Store_id?',
    component: StoreAddTab,
  },
  {
    path: '/country/add/:country_id?',
    component: CountryAddTab,
  },
  {
    path: '/governorate',
    component: GovernorateList,
  },
  {
    path: '/governorate/add/:governorate_id?',
    component: GovernorateAddTab,
  },
  {
    path: '/area',
    component: AreaList,
  },
  {
    path: '/area/add/:area_id?',
    component: AreaAddTab,
  },
  {
    path: '/city',
    component: CityList,
  },
  {
    path: '/city/add/:id?',
    component: CityAddTab,
  },
  {
    path: '/package/add/:package_id?',
    component: EventAddTab,
  },
  {
    path: '/payment-type',
    component: PaymentTypeList,
  },
  {
    path: '/payment-type/add/:payment_type_id?',
    component: PaymentTypeAddTab,
  },
  {
    path: '/yacht-policy',
    component: YachtPolicyAddTab,
  },
  {
    path: '/privacy-policy-user',
    component: PrivacyPolicyAddTab,
  },
  {
    path: '/privacy-policy-owner',
    component: PrivacyPolicyOwnerAddTab,
  },
  {
    path: '/terms-conditions-user',
    component: TermsAddTab,
  },
  {
    path: '/terms-conditions-owner',
    component: TermsOwnerAddTab,
  },
  {
    path: '/refund-policy',
    component: RefundPolicyTab,
  },
  {
    path: '/seller-policy',
    component: SellerPolicyTab,
  },
  {
    path: '/buyer-policy',
    component: BuyerPolicyTab,
  },
  {
    path: '/chalet-policy',
    component: ChaletPolicyAdd,
  },
  {
    path: '/chalet-refund-policy',
    component: ChaletRefundPolicyAdd,
  },
  {
    path: '/data-deletion-policy',
    component: DataDeletionPolicyAdd,
  },
  {
    path: '/about',
    component: AboutUsAddTab,
  },
  {
    path: '/contact-us',
    component: ContactUsList,
  },
  {
    path: '/contact-us/add/:id?',
    component: ContactDetails,
  },
  {
    path: '/client-setting',
    component: ClientDetails,
  },
  {
    path: '/client-settings/:id?',
    component: ClientSettingDetails,
  },
  {
    path: '/bulk-coupon',
    component: BulkCoupon,
  },
  {
    path: '/coupon-report',
    component: CouponReportList,
  },
  {
    path: '/onboard-setting',
    component: OnboardingSetting,
  },
  {
    path: '/home-messages',
    component: HomeScreenMessages,
  },
  {
    path: '/cruise-facilities',
    component: CruiseFacilities,
  },
  {
    path: '/voucher',
    component: VoucherLists,
  },
  {
    path: '/voucher/add/:voucherId?',
    component: VoucherAddTab,
  },
  {
    path: '/item-categories',
    component: ItemCategoryList,
  },
  {
    path: '/item-categories/add/:id?',
    component: ItemCategoryAddTab,
  },
  {
    path: '/trips',
    component: TripList,
  },
  {
    path: '/trips/:action/:id?',
    component: TripAddEdit,
  },
  {
    path: '/activities-master',
    component: ActivitiesList,
  },
  {
    path: '/activities-master/:action/:id?',
    component: ActivitiesAddEdit,
  },
  {
    path: '/notification-v2',
    component: NotificationAddV2,
  },
  {
    path: '/push-composer',
    component: PushComposer,
  },
  {
    path: '/push-history',
    component: PushHistory,
  },
  {
    path: '/areas',
    component: AreaList,
  },
  {
    path: '/store-map-view',
    component: StoreMapView,
  },
  {
    path: '/ads',
    component: AdsList,
  },
  {
    path: '/ads/add',
    component: AdsAddTab,
  },
  {
    path: '/ads/add/:id',
    component: AdsAddTab,
  },
  {
    path: '/chalet-master',
    component: ChaletList,
  },
  {
    path: '/chalet-master/add',
    component: ChaletAddTab,
  },
  {
    path: '/chalet-master/add/:id',
    component: ChaletAddTab,
  },
  {
    path: '/chalet-bookings',
    component: ChaletBookingList,
  },
  {
    path: '/chalet-booking-details/:booking_id',
    component: ChaletBookingDetail,
  },
  {
    path: '/chalet-details/:id',
    component: ChaletDetails,
  },
  {
    path: '/diwaniya',
    component: DiwaniyaMasterList,
  },
  {
    path: '/diwaniya/add',
    component: DiwaniyaMasterAddTab,
  },
  {
    path: '/diwaniya/add/:id',
    component: DiwaniyaMasterAddTab,
  },
  {
    path: '/admin-review',
    component: ReviewList,
  },
  {
    path: '/admin-review/add',
    component: ReviewAddTab,
  },
  {
    path: '/admin-review/edit/:id',
    component: ReviewAddTab,
  },
  {
    path: '/all-users',
    component: AllUserList,
  },
  {
    path: '/all-owner-captains/:owner_id/:owner_name',
    component: AllUserList,
  },
  {
    path: '/all-users/:action/:id?',
    component: AddNewUser,
  },
  {
    path: '/all-users/:action/:tab_type/:id',
    component: AddNewUser,
  },
  {
    path: '/holiday-price/:source_id',
    component: HolidayPriceList,
  },
  {
    path: '/holiday-price/add/:source_id',
    component: HolidayPriceAddTab,
  },
  {
    path: '/holiday-price/add/:source_id/:id',
    component: HolidayPriceAddTab,
  },
  {
    path: '/chalet-package/:source_id',
    component: ChaletPackageList,
  },
  {
    path: '/chalet-package/add/:source_id',
    component: ChaletPackageAddTab,
  },
  {
    path: '/chalet-package/add/:source_id/:id',
    component: ChaletPackageAddTab,
  },
  {
    path: '/chalet-slot/:source_id',
    component: ChaletSlotList,
  },
  {
    path: '/chalet-slot/add/:source_id',
    component: ChaletSlotAddTab,
  },
  {
    path: '/chalet-diwaniya/:source_id',
    component: ChaletDiwaniyaList,
  },
  {
    path: '/version-history',
    component: VersionHistoryList,
  },
  {
    path: '/version-history/add',
    component: VersionHistoryAdd,
  },
  {
    path: '/version-history/add/:id',
    component: VersionHistoryAdd,
  },
  {
    path: '/chalet-owner',
    component: ChaletOwnerList,
  },
  {
    path: '/chalet-owner/add',
    component: ChaletOwnerAddTab,
  },
  {
    path: '/chalet-owner/add/:id',
    component: ChaletOwnerAddTab,
  },
  {
    path: '/chalet-global-packages',
    component: ChaletGlobalPackage,
  },
  {
    path: '/chalet-global-package/:type/:id?',
    component: PackageAddEdit,
  },
  {
    path: '/chalet-category',
    component: ChaletCategoryList,
  },
  {
    path: '/chalet-category/add',
    component: ChaletCategoryAddTab,
  },
  {
    path: '/chalet-category/add/:id',
    component: ChaletCategoryAddTab,
  },
  {
    path: '/offers',
    component: OfferList,
  },
  {
    path: '/offers/add',
    component: OfferAddTab,
  },
  {
    path: '/offers/add/:id',
    component: OfferAddTab,
  },
  {
    path: '/offers-category/:offerId',
    component: OfferCategoryList,
  },
  {
    path: '/offers-category/add/:offerId',
    component: OfferCategoryAddTab,
  },
  {
    path: '/offers-category/add/:offerId/:id',
    component: OfferCategoryAddTab,
  },
  {
    path: '/all-bookings/:type?',
    component: AllBookings,
  },
  {
    path: '/event-reports',
    component: EventReport,
  },
  {
    path: '/wallet-reports',
    component: WalletReport,
  },
  {
    path: '/voucher-reports',
    component: VoucherReport,
  },
  {
    path: '/uploads',
    component: UploadsAdd,
  },
  {
    path: '/store-report',
    component: StoreReport,
  },
  {
    path: '/journey-list',
    component: JourneyList,
  },
  {
    path: '/journey/:type/:id?',
    component: JourneyAddEdit,
  },
  {
    path: '/car-company',
    component: CarCompanyList,
  },
  {
    path: '/car-company/add',
    component: CarCompanyAddTab,
  },
  {
    path: '/car-company/add/:id',
    component: CarCompanyAddTab,
  },
  {
    path: '/car/:companyId',
    component: CarList,
  },
  {
    path: '/car/add/:companyId',
    component: CarAddTab,
  },
  {
    path: '/car/add/:companyId/:id',
    component: CarAddTab,
  },
  {
    path: '/car-category',
    component: CarCategoryList,
  },
  {
    path: '/car-category/add',
    component: CarCategoryAdd,
  },
  {
    path: '/car-category/add/:id',
    component: CarCategoryAdd,
  },
  {
    path: '/car-pricing/:companyId/:carId',
    component: CarPricingList,
  },
  {
    path: '/car-pricing/add/:companyId/:carId',
    component: CarPricingAdd,
  },
  {
    path: '/car-pricing/add/:companyId/:carId/:id',
    component: CarPricingAdd,
  },
  {
    path: '/concierge-cruise',
    component: ConciergeCruiseAdd,
  },
  {
    path: '/concierge-event',
    component: ConciergeEventAdd,
  },
  {
    path: '/concierge-chalet',
    component: ConciergeChaletAdd,
  },
  {
    path: '/add-ons',
    component: AddOns,
  },
  {
    path: '/cruise-complaint',
    component: CruiseComplaint,
  },
  {
    path: '/complaint-report',
    component: ComplaintReport,
  },
  {
    path: '/financial-report',
    component: FinancialReport,
  },
  {
    path: '/contract-files/:type/:type_id',
    component: ContractFiles,
  },
  {
    path: '/car-pickup',
    component: CarPickupList,
  },
  {
    path: '/car-pickup/add',
    component: CarPickupAddTab,
  },
  {
    path: '/event-holiday-price/:source_id',
    component: EventHolidayPriceList,
  },
  {
    path: '/event-holiday-price/add/:source_id',
    component: EventHolidayPriceAddTab,
  },
  {
    path: '/event-holiday-price/add/:source_id/:id',
    component: EventHolidayPriceAddTab,
  },
  {
    path: '/mina-report',
    component: MinaReport,
  },
  {
    path: '/create-page-meta-data/:type/:id?',
    component: PagesMetaDataCreate,
  },
  {
    path: '/faq-list',
    component: FaqModuleList,
  },
  {
    path: '/faq/add/:id?',
    component: FaqModuleAdd,
  },
  {
    path: '/service/add',
    component: ServiceAddTab,
  },
  {
    path: '/service/add/:id',
    component: ServiceAddTab,
  },
  {
    path: '/airport/add',
    component: AirportAddTab,
  },
  {
    path: '/airport/add/:id',
    component: AirportAddTab,
  },
  {
    path: '/airport-list',
    component: AirportList,
  },
  {
    path: '/flight-redirect-list',
    component: FlightRedirectList,
  },
  {
    path: '/annual-report',
    component: AnnualReport,
  },
  {
    path: '/cruise-trip-destination',
    component: CruiseDestinationList,
  },
  {
    path: '/cruise-trip-destination/add',
    component: CruiseDestinationAddTab,
  },
  {
    path: '/cruise-trip-destination/add/:id',
    component: CruiseDestinationAddTab,
  },
  {
    path: '/cruise-trip',
    component: CruiseTripList,
  },
  {
    path: '/cruise-trip/add',
    component: CruiseTripAddTab,
  },
  {
    path: '/cruise-trip/add/:id',
    component: CruiseTripAddTab,
  },
  {
    path: '/cruise-trip-details/:id',
    component: CruiseTripDetails,
  },
  {
    path: '/cruise-trip-slots/:tripId',
    component: CruiseTripSlotList,
  },
  {
    path: '/cruise-trip-slots/:tripId/add',
    component: CruiseTripSlotAddTab,
  },
  {
    path: '/trip-cruise',
    component: TripCruiseList,
  },
  {
    path: '/trip-cruise/add',
    component: TripCruiseAddTab,
  },
  {
    path: '/trip-cruise/add/:id',
    component: TripCruiseAddTab,
  },
  {
    path: '/trip-cabin/:cruiseId',
    component: TripCabinList,
  },
  {
    path: '/trip-cabin/:cruiseId/add',
    component: TripCabinAddTab,
  },
  {
    path: '/trip-cabin/:cruiseId/add/:id',
    component: TripCabinAddTab,
  },
  {
    path: '/cruise-trip-cabin-price/:tripId/:cruiseId',
    component: TripCabinPrice,
  },
  {
    path: '/cruise-trip-itinerary/:tripId',
    component: TripItineraryList,
  },
  {
    path: '/cruise-trip-itinerary/:tripId/add',
    component: TripItineraryAddTab,
  },
  {
    path: '/cruise-trip-itinerary/:tripId/add/:id',
    component: TripItineraryAddTab,
  },
  {
    path: '/cruise-trip-booking-details/:id',
    component: CruiseTripBookingDetail,
  },
  {
    path: '/trip-reports',
    component: BasicReportTrip,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/boat-block-date-lists',
    component: BoatBlockDateList,
  },
  {
    path: '/boatsmaster/:boatType?/:boatId?/boat-block-date-add/:boat_block_date_id?',
    component: BoatMasterBlockDateAddTab,
  },
  {
    path: '/concierge-kashta-book',
    component: ConciergeKashtaAdd,
  },
]

class Routes extends Component {
  constructor(props) {
    super(props)
    this.audio = new Audio(NotificationSound)
    this.state = {
      notificationCount: 0,
    }
  }

  clearNotificationCount = () => {
    this.setState({ notificationCount: 0 })
  }

  adminRoles = [
    'super-admin',
    'ops-coord',
    'sr-ops-coord',
    'ops-sup',
    'ops-mgr',
    'mkt-mgr',
    'mkt-coord',
    'sales-mgr',
    'sales-member',
    'finance-mgr',
    'finance-member',
    'owners',
  ]

  componentDidMount() {
    const userRole = localStorage.getItem('loged_In_role')
    const validRoles = getAllUserTypes().map((item) => item.value)

    if (validRoles.includes(userRole) && !['store', 'wego-admin'].includes(userRole)) {
      try {
        this.socket = io.connect(socketUrl(), {
          transports: ['websocket'],
        })
        this.socket.emit('join', { room: 'super-admin-notifications' })

        // Add port-admin to booking-notifications room
        // if (userRole === 'port-admin') {
        //   this.socket.emit('join', { room: 'booking-notifications' })
        // }
        console.log('notification logs startetd', userRole)

        this.socket.on('notification', this.handleNotification)
      } catch (err) {
        // Handle errors gracefully
      }
    }
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.off('notification', this.handleNotification)
      this.socket.disconnect()
    }
  }

  handleNotification = (data) => {
    this.audio.play()
    this.setState((prev) => ({ notificationCount: prev.notificationCount + 1 }))

    // Trigger Header component to refresh notification count immediately
    window.dispatchEvent(new CustomEvent('new-notification-received'))

    const userRole = localStorage.getItem('loged_In_role')
    const validRoles = getAllUserTypes().map((item) => item.value)
    if (!validRoles.includes(userRole) || ['store', 'wego-admin'].includes(userRole)) return

    if (data.notification_type === 'payment-success') {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: `You received ${data?.data?.amount} for the ${data?.data?.booking_type || ''} order number ${data?.data?.order_number} in ${data?.data?.country}`,
        showConfirmButton: false,
        timer: 2500,
      })
    }

    // Handle new booking notification for port-admin users
    if (userRole === 'port-admin') {
      const bookingData = data?.data || {}
      console.log(bookingData, 'bookingData')

      Swal.fire({
        title: 'New Booking Confirmation',
        html: `
          <div class="swal-booking">
            <table>
              <tr>
                <td><strong>Order #:</strong></td>
                <td>${bookingData?.order_number || 'N/A'}</td>
              </tr>
              <tr>
                <td><strong>Customer:</strong></td>
                <td>${bookingData?.customer_name || 'N/A'}</td>
              </tr>
              <tr>
                <td><strong>Cruise:</strong></td>
                <td>${bookingData?.cruise_name_en || '–'} / ${bookingData?.cruise_name_ar || '–'}</td>
              </tr>
              <tr>
                <td><strong>Date:</strong></td>
                <td>${bookingData?.booking_date || 'N/A'}</td>
              </tr>
              <tr>
                <td><strong>Status:</strong></td>
                <td>${bookingData?.booking_status || 'New'}</td>
              </tr>
            </table>
          </div>
        `,
        icon: 'info',
        width: 500,
        showCancelButton: false,
        confirmButtonText: 'Confirm Booking',
        customClass: {
          popup: 'swal2-border-radius',
          title: 'swal2-title-custom',
          content: 'swal2-content-custom',
        },
        didOpen: () => {
          // Inject some quick styles
          const style = document.createElement('style')
          style.textContent = `
            .swal2-border-radius {
              border-radius: 12px !important;
            }
            .swal2-title-custom {
              font-size: 1.5rem !important;
              margin-bottom: 0.5rem !important;
            }
            .swal2-content-custom {
              font-size: 1rem !important;
            }
            .swal-booking table {
              width: 100%;
              border-collapse: collapse;
            }
            .swal-booking td {
              padding: 6px 4px;
              vertical-align: top;
            }
            .swal-booking td:first-child {
              color: #555;
              width: 40%;
            }
            .swal-booking td:last-child {
              font-weight: 500;
            }
          `
          document.head.appendChild(style)
        },
      }).then((result) => {
        if (result.isConfirmed && bookingData?.id) {
          // Redirect to booking details page
          window.location.href = `/#/booking-details/${bookingData.id}`
        }
      })
    }

    if (data.notification_type === 'new-notification') {
      // Show toast notification for new notification
      const notificationData = data || {}

      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'info',
        html: `
          <div style="display: flex; flex-direction: column; gap: 2px; padding-left: 10px;">
            <div style="font-size: 14px; font-weight: 600; color: #333; line-height: 1.4; text-align: left;">
              ${notificationData?.title_en || 'New Notification'}
            </div>
            <div style="font-size: 12px; color: #666; line-height: 1.5; text-align: left;">
              ${notificationData?.message_en || 'You have a new notification'}
            </div>
          </div>
        `,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: 'notification-toast-popup',
          icon: 'notification-toast-icon',
        },
        didOpen: (toast) => {
          const style = document.createElement('style')
          style.textContent = `
            .notification-toast-popup {
              border-radius: 8px !important;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
              min-width: 350px !important;
              max-width: 450px !important;
              cursor: pointer !important;
              padding: 12px 16px !important;
              background: #fff !important;
            }
            .notification-toast-popup:hover {
              box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2) !important;
            }
            .notification-toast-popup .swal2-icon {
              width: 32px !important;
              height: 32px !important;
              margin: 0 10px 0 0 !important;
              border-width: 2px !important;
              flex-shrink: 0 !important;
              color: #2196f3 !important;
              border-color: #2196f3 !important;
            }
            .notification-toast-popup .swal2-html-container {
              margin: 0 !important;
              padding: 0 !important;
              text-align: left !important;
            }
            .swal2-timer-progress-bar {
              background: #2196f3 !important;
              height: 3px !important;
            }
          `
          document.head.appendChild(style)

          toast.addEventListener('click', () => {
            Swal.close()
            window.location.href = '/#/notifications'
          })
        },
      })
    }
  }

  render() {
    const countryShortName = localStorage.getItem('countryShortName') || 'KWT'
    const userRole = localStorage.getItem('loged_In_role')
    const isSuperAdmin = this.adminRoles.includes(userRole)
    const availableRoutes = isSuperAdmin ? superAdminRoutes : roleRoutes[userRole]

    // Set global timezone
    Moment.globalTimezone = getCountryTimeZone(countryShortName)

    return (
      <Context.Provider value={{ ...this.state, clearNotificationCount: this.clearNotificationCount }}>
        <Router baseName={'/'}>
          {availableRoutes ? (
            <Home>
              <Switch>
                {availableRoutes.map((route, index) => (
                  <Route
                    key={index}
                    exact
                    path={route.path}
                    component={route.component}
                  />
                ))}
              </Switch>
            </Home>
          ) : (
            <Switch>
              <Route
                exact
                path="/"
                component={Login}
              />
            </Switch>
          )}
        </Router>
      </Context.Provider>
    )
  }
}

export default Routes
